"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
/* eslint-disable class-methods-use-this */
const debug_1 = __importDefault(require("debug"));
const get_youtube_id_1 = __importDefault(require("get-youtube-id"));
const exchange_markdown_editor_common_1 = require("@mulesoft/exchange-markdown-editor-common");
const defaults_1 = __importDefault(require("./defaults"));
const utils_1 = require("./utils");
const log = (0, debug_1.default)('exchange-parser:renderer');
const allowedOrigins = [
    {
        get: (url) => {
            const youTubeId = (0, get_youtube_id_1.default)(url);
            if (youTubeId) {
                return `https://www.youtube.com/embed/${youTubeId}?rel=0&amp;controls=0&amp;showinfo=0`;
            }
            return null;
        },
        style: {
            container: {
                background: 'grey',
                position: 'relative',
                width: '100%',
                height: '0',
                'padding-bottom': '56.25%'
            },
            cookieDiv: {
                color: 'white',
                padding: '30px;',
                position: 'absolute',
                top: '0',
                bottom: '0',
                left: '0',
                right: '0',
                display: 'flex',
                'z-index': '0',
                'align-items': 'center',
                'justify-content': 'center'
            },
            frame: {
                position: 'absolute',
                'z-index': 1,
                top: '0',
                left: '0',
                width: '100%',
                height: '100%'
            }
        }
    }
];
const validTags = ['br', 'img'];
const allowedAnchorTargets = ['_blank'];
function getAllowedOrigin(href) {
    return allowedOrigins.find((o) => o.get(href));
}
function buildStyle(style) {
    return Object.keys(style).reduce((accum, current) => `${accum}${current}:${style[current]};`, '');
}
function isTag(text, tag) {
    const trimmed = text.toLowerCase().trim();
    return (trimmed.startsWith(`<${tag} `) ||
        trimmed === `<${tag}>` ||
        trimmed === `<${tag}/>`);
}
class Renderer {
    constructor(options) {
        this.strong = (text) => {
            log('Rendering strong', text);
            text = (0, utils_1.getText)(text);
            return [
                {
                    type: 'strong',
                    text: `<strong>${text}</strong>`,
                    innerText: text
                }
            ];
        };
        this.em = (text) => {
            log('Rendering em', text);
            text = (0, utils_1.getText)(text);
            return [
                {
                    type: 'em',
                    text: `<em>${text}</em>`,
                    innerText: text
                }
            ];
        };
        this.codespan = (text) => {
            log('Rendering codespan', text);
            text = (0, utils_1.getText)(text);
            return [
                {
                    type: 'code',
                    text: `<code>${text}</code>`,
                    innerText: text
                }
            ];
        };
        this.br = () => {
            log('Rendering br');
            return [
                {
                    type: 'br',
                    text: '<br>',
                    innerText: '\n'
                }
            ];
        };
        this.del = (text) => {
            log('Rendering del', text);
            text = (0, utils_1.getText)(text);
            return [
                {
                    type: 'del',
                    text: `<del>${text}</del>`,
                    innerText: text
                }
            ];
        };
        this.link = (href, title, text, target) => {
            log('Rendering link', href, title, text, target);
            text = (0, utils_1.getText)(text);
            let prot;
            try {
                prot = decodeURIComponent((0, exchange_markdown_editor_common_1.unescape)(href))
                    .replace(/[^\w:]/g, '')
                    .toLowerCase();
            }
            catch (e) {
                return [
                    {
                        type: 'text',
                        text: (0, utils_1.getText)(text),
                        innerText: (0, utils_1.getText)(text)
                    }
                ];
            }
            if (
            // eslint-disable-next-line no-script-url
            prot.indexOf('javascript:') === 0 ||
                prot.indexOf('vbscript:') === 0 ||
                prot.indexOf('data:') === 0) {
                return [
                    {
                        type: 'text',
                        text: (0, utils_1.getText)(text),
                        innerText: (0, utils_1.getText)(text)
                    }
                ];
            }
            let out = `<a href="${(this.options.hrefSrc
                ? this.options.hrefSrc(href !== null && href !== void 0 ? href : '')
                : (href !== null && href !== void 0 ? href : '')).replace(/"/g, '%22')}"`;
            if (title) {
                out += ` title="${title}"`;
            }
            if (target && allowedAnchorTargets.includes(target)) {
                out += ` target="${target}"`;
            }
            out += ` rel="noopener noreferrer">${text}</a>`;
            return [
                {
                    type: 'link',
                    text: out,
                    innerText: text
                }
            ];
        };
        this.attachment = (href, title, text) => {
            log('Rendering attachment', href, title, text);
            text = (0, utils_1.getText)(text);
            const origin = getAllowedOrigin(href);
            let prot;
            try {
                prot = decodeURIComponent((0, exchange_markdown_editor_common_1.unescape)(href))
                    .replace(/[^\w:]/g, '')
                    .toLowerCase();
            }
            catch (e) {
                return [];
            }
            if (
            // eslint-disable-next-line no-script-url
            prot.indexOf('javascript:') === 0 ||
                prot.indexOf('vbscript:') === 0 ||
                prot.indexOf('data:') === 0) {
                return [];
            }
            const cookieMessage = '⚠ Your browser has cookies disabled. You must have all cookies enabled for video playback to work';
            const iframeOnloadScript = "if((!window.OptanonWrapper || window.OptanonWrapper&&OptanonActiveGroups&&OptanonActiveGroups.match(/,4,/))&&!this.src){this.src=this.getAttribute('data-src'); this.className='';}";
            if (origin) {
                return [
                    {
                        type: 'attachment',
                        text: `<div style="${buildStyle(origin.style.container)}"><div style="${buildStyle(origin.style.cookieDiv)}">${cookieMessage}</div><iframe style="${buildStyle(origin.style.frame)}" data-src="${origin.get(encodeURI(href))}" frameborder="0" allowfullscreen class="exchange-category-4" onload="${iframeOnloadScript}"></iframe></div>`,
                        innerText: ''
                    }
                ];
            }
            return [
                {
                    type: 'image',
                    text: `<img src="${(this.options.imgSrc
                        ? this.options.imgSrc(href || '')
                        : href || '').replace(/"/g, '%22')}"${text ? ` alt="${text}"` : ''}${title ? ` title="${title}"` : ''}>`,
                    innerText: ''
                }
            ];
        };
        this.tag = (text) => {
            log('Rendering tag', text);
            if (!validTags.some((validTag) => isTag(text, validTag))) {
                return [];
            }
            if (this.options.imgSrc && isTag(text, 'img')) {
                const [, src] = /\s+src\s*=\s*"([\s\S]+?)"/i.exec(text) || [];
                text = text.replace(src, this.options.imgSrc);
            }
            return [
                {
                    type: 'tag',
                    text,
                    innerText: ''
                }
            ];
        };
        this.text = (text) => {
            log('Rendering text', text);
            return [
                {
                    type: 'text',
                    text: (0, utils_1.getText)(text),
                    innerText: (0, utils_1.getText)(text)
                }
            ];
        };
        this.options = { ...defaults_1.default, ...options };
    }
}
exports.default = Renderer;
